package com.evoapps.evoshift.ui.user

import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.widgets.SurfaceCard
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.ui.theme.animateItemIfMotion
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.automirrored.filled.CallSplit
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.model.AllocationBasis
import com.evoapps.evoshift.domain.model.AllocationMethod
import com.evoapps.evoshift.domain.model.RecurringCostRule
import com.evoapps.evoshift.domain.model.SharedCost
import com.evoapps.evoshift.domain.model.SharedCostAllocation
import com.evoapps.evoshift.domain.model.SharedCostFrequency
import com.evoapps.evoshift.domain.usecase.owner.BusinessMonth
import com.evoapps.evoshift.ui.adaptive.AdaptiveCardGrid
import com.evoapps.evoshift.ui.adaptive.WideContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.finance.RevenueGreen
import com.evoapps.evoshift.ui.finance.formatMoney
import com.evoapps.evoshift.ui.finance.formatPercent
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.ui.util.monthName
import com.evoapps.evoshift.viewmodels.SharedCostsEvent
import com.evoapps.evoshift.viewmodels.SharedCostsViewModel
import com.evoapps.evoshift.viewmodels.WorkplaceInfo
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.DialogSectionLabel
import com.evoapps.evoshift.widgets.DialogWidth
import com.evoapps.evoshift.widgets.EvoCheckboxRow
import com.evoapps.evoshift.widgets.EvoConfirmDialog
import com.evoapps.evoshift.widgets.EvoDateField
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoDropdown
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.LoadingOverlay
import com.evoapps.evoshift.widgets.formatEditable
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.widgets.parseDecimal
import com.evoapps.evoshift.widgets.parseIsoDate
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.allocation_basis_equal
import evoshift.composeapp.generated.resources.allocation_basis_income
import evoshift.composeapp.generated.resources.allocation_basis_labour_cost
import evoshift.composeapp.generated.resources.allocation_basis_net_sales
import evoshift.composeapp.generated.resources.allocation_method_fixed
import evoshift.composeapp.generated.resources.allocation_method_percentages
import evoshift.composeapp.generated.resources.allocation_method_proportional
import evoshift.composeapp.generated.resources.business_month_note
import evoshift.composeapp.generated.resources.business_month_shared
import evoshift.composeapp.generated.resources.business_month_title
import evoshift.composeapp.generated.resources.delete
import evoshift.composeapp.generated.resources.edit
import evoshift.composeapp.generated.resources.field_required
import evoshift.composeapp.generated.resources.frequency_monthly
import evoshift.composeapp.generated.resources.frequency_one_off
import evoshift.composeapp.generated.resources.frequency_yearly
import evoshift.composeapp.generated.resources.monthly_result_costs
import evoshift.composeapp.generated.resources.monthly_result_result
import evoshift.composeapp.generated.resources.monthly_result_revenue
import evoshift.composeapp.generated.resources.name
import evoshift.composeapp.generated.resources.number_invalid
import evoshift.composeapp.generated.resources.save
import evoshift.composeapp.generated.resources.shared_cost_add_title
import evoshift.composeapp.generated.resources.shared_cost_amount
import evoshift.composeapp.generated.resources.shared_cost_basis
import evoshift.composeapp.generated.resources.shared_cost_convert_note
import evoshift.composeapp.generated.resources.shared_cost_convert_title
import evoshift.composeapp.generated.resources.shared_cost_date
import evoshift.composeapp.generated.resources.shared_cost_delete_confirm
import evoshift.composeapp.generated.resources.shared_cost_edit_title
import evoshift.composeapp.generated.resources.shared_cost_end_month
import evoshift.composeapp.generated.resources.shared_cost_error_end
import evoshift.composeapp.generated.resources.shared_cost_error_negative
import evoshift.composeapp.generated.resources.shared_cost_error_workplaces
import evoshift.composeapp.generated.resources.shared_cost_frequency
import evoshift.composeapp.generated.resources.shared_cost_method
import evoshift.composeapp.generated.resources.shared_cost_months_between
import evoshift.composeapp.generated.resources.shared_cost_months_from
import evoshift.composeapp.generated.resources.shared_cost_name_hint
import evoshift.composeapp.generated.resources.shared_cost_no_end
import evoshift.composeapp.generated.resources.shared_cost_note_equal
import evoshift.composeapp.generated.resources.shared_cost_note_income
import evoshift.composeapp.generated.resources.shared_cost_note_labour_cost
import evoshift.composeapp.generated.resources.shared_cost_note_net_sales
import evoshift.composeapp.generated.resources.shared_cost_part
import evoshift.composeapp.generated.resources.shared_cost_part_share
import evoshift.composeapp.generated.resources.shared_cost_preview_fallback
import evoshift.composeapp.generated.resources.shared_cost_preview_title
import evoshift.composeapp.generated.resources.shared_cost_split_label
import evoshift.composeapp.generated.resources.shared_cost_start_month
import evoshift.composeapp.generated.resources.shared_cost_sum_missing_amount
import evoshift.composeapp.generated.resources.shared_cost_sum_missing_percent
import evoshift.composeapp.generated.resources.shared_cost_sum_ok
import evoshift.composeapp.generated.resources.shared_cost_sum_over_amount
import evoshift.composeapp.generated.resources.shared_cost_sum_over_percent
import evoshift.composeapp.generated.resources.shared_cost_workplaces
import evoshift.composeapp.generated.resources.shared_costs_add
import evoshift.composeapp.generated.resources.shared_costs_add_first
import evoshift.composeapp.generated.resources.shared_costs_count
import evoshift.composeapp.generated.resources.shared_costs_manage
import evoshift.composeapp.generated.resources.shared_costs_empty
import evoshift.composeapp.generated.resources.shared_costs_empty_hint
import evoshift.composeapp.generated.resources.shared_costs_intro
import evoshift.composeapp.generated.resources.shared_costs_title
import kotlinx.datetime.YearMonth
import kotlinx.datetime.minusMonth
import kotlinx.datetime.number
import kotlinx.datetime.plusMonth
import org.jetbrains.compose.resources.stringResource

/*
 * SH-131: "Koszty wspólne firmy", the owner's costs of the business as a whole, split across the
 * workplaces they own. A card per cost with its split; the editor shows the split live and saves
 * only once it adds up. Each workplace's part becomes a read-only cost of its month (Financials).
 */

@Composable
fun SharedCostsScreen(
    viewModel: SharedCostsViewModel,
    onNavigateBack: () -> Unit
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val snackbarHostState = remember { SnackbarHostState() }
    var editing by remember { mutableStateOf<SharedCost?>(null) }
    var toDelete by remember { mutableStateOf<SharedCost?>(null) }

    val errorText = state.error?.asString()
    val successText = state.successMessage?.asString()
    LaunchedEffect(errorText, successText) {
        (errorText ?: successText)?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(SharedCostsEvent.MessageShown)
        }
    }
    // A save that went through closes the editor.
    LaunchedEffect(state.savedAt) { if (state.savedAt > 0) editing = null }
    // "Convert to a shared cost": the editor opens filled in from the rule.
    val converting = state.converting
    LaunchedEffect(converting, state.workplaces) {
        if (converting != null && state.workplaces.isNotEmpty() && editing == null) editing = viewModel.fromRule(converting)
    }

    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        topBar = {
            EvoTopBar(
                title = stringResource(Res.string.shared_costs_title),
                onBack = onNavigateBack,
                actions = listOf(helpAction(HelpPage.SHARED_COSTS))
            )
        },
        floatingActionButton = {
            if (state.workplaces.isNotEmpty()) FloatingActionButton(onClick = { editing = viewModel.blank() }) {
                Icon(Icons.Default.Add, contentDescription = stringResource(Res.string.shared_costs_add))
            }
        }
    ) { padding ->
        Box(modifier = Modifier.padding(padding).fillMaxSize().contentWidth(WideContentMaxWidth)) {
            AdaptiveCardGrid(modifier = Modifier.fillMaxSize().padding(16.dp), contentPadding = PaddingValues(0.dp)) {
                item(span = { GridItemSpan(maxLineSpan) }) {
                    Text(
                        stringResource(Res.string.shared_costs_intro),
                        style = MaterialTheme.typography.bodyMedium,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
                state.business?.takeIf { it.hasFigures && state.workplaces.size > 1 }?.let { business ->
                    item(span = { GridItemSpan(maxLineSpan) }) {
                        BusinessMonthCard(business, state.workplaces.values.firstOrNull()?.currency ?: "PLN")
                    }
                }
                if (state.costs.isEmpty() && !state.isLoading) {
                    item(span = { GridItemSpan(maxLineSpan) }) {
                        Column(Modifier.fillMaxWidth().padding(24.dp), horizontalAlignment = Alignment.CenterHorizontally) {
                            Text(stringResource(Res.string.shared_costs_empty), style = MaterialTheme.typography.bodyLarge)
                            Text(
                                stringResource(Res.string.shared_costs_empty_hint),
                                style = MaterialTheme.typography.bodyMedium,
                                color = MaterialTheme.colorScheme.onSurfaceVariant
                            )
                        }
                    }
                }
                items(state.costs, key = { it.id }) { cost ->
                    Box(Modifier.animateItemIfMotion(this), propagateMinConstraints = true) {
                        SharedCostCard(
                            cost = cost,
                            workplaces = state.workplaces,
                            basis = cost.basis?.let { state.basis[it] }.orEmpty(),
                            month = state.month,
                            onEdit = { editing = cost },
                            onDelete = { toDelete = cost }
                        )
                    }
                }
                item(span = { GridItemSpan(maxLineSpan) }) { Spacer(Modifier.height(80.dp)) }
            }
            LoadingOverlay(isLoading = state.isLoading && state.costs.isEmpty())
        }
    }

    editing?.let { cost ->
        val rule = state.converting?.takeIf { cost.id.isBlank() }
        SharedCostDialog(
            initial = cost,
            workplaces = state.workplaces,
            basis = state.basis,
            month = state.month,
            converting = rule,
            isSaving = state.isSaving,
            onDismiss = {
                editing = null
                if (rule != null) viewModel.onEvent(SharedCostsEvent.ConversionDismissed)
            },
            onSave = { viewModel.onEvent(SharedCostsEvent.Save(it, rule?.id)) }
        )
    }

    toDelete?.let { cost ->
        EvoConfirmDialog(
            title = stringResource(Res.string.delete),
            text = stringResource(Res.string.shared_cost_delete_confirm, cost.name),
            confirmLabel = stringResource(Res.string.delete),
            onConfirm = {
                viewModel.onEvent(SharedCostsEvent.Delete(cost.id))
                toDelete = null
            },
            onDismiss = { toDelete = null },
            destructive = true,
            icon = Icons.Default.Delete
        )
    }
}

@Composable
internal fun SharedCostFrequency.label(): String = stringResource(
    when (this) {
        SharedCostFrequency.ONE_OFF -> Res.string.frequency_one_off
        SharedCostFrequency.MONTHLY -> Res.string.frequency_monthly
        SharedCostFrequency.YEARLY -> Res.string.frequency_yearly
    }
)

@Composable
internal fun AllocationMethod.label(): String = stringResource(
    when (this) {
        AllocationMethod.PERCENTAGES -> Res.string.allocation_method_percentages
        AllocationMethod.FIXED_AMOUNTS -> Res.string.allocation_method_fixed
        AllocationMethod.PROPORTIONAL -> Res.string.allocation_method_proportional
    }
)

@Composable
internal fun AllocationBasis.label(): String = stringResource(
    when (this) {
        AllocationBasis.NET_SALES -> Res.string.allocation_basis_net_sales
        AllocationBasis.INCOME -> Res.string.allocation_basis_income
        AllocationBasis.LABOUR_COST -> Res.string.allocation_basis_labour_cost
        AllocationBasis.EQUAL -> Res.string.allocation_basis_equal
    }
)

@Composable
private fun AllocationBasis.note(): String = stringResource(
    when (this) {
        AllocationBasis.NET_SALES -> Res.string.shared_cost_note_net_sales
        AllocationBasis.INCOME -> Res.string.shared_cost_note_income
        AllocationBasis.LABOUR_COST -> Res.string.shared_cost_note_labour_cost
        AllocationBasis.EQUAL -> Res.string.shared_cost_note_equal
    }
)

/** "Październik 2026". */
@Composable
private fun monthLabel(month: YearMonth): String = "${monthName(month.month.number)} ${month.year}"

private fun yearMonthOf(text: String?): YearMonth? = runCatching { YearMonth.parse(text!!) }.getOrNull()

/** What the cost charges in a month, for the preview: a twelfth of a yearly cost. */
private fun monthTotalOf(cost: SharedCost): Double =
    if (cost.frequency == SharedCostFrequency.YEARLY) SharedCostAllocation.round2(cost.amount / 12) else cost.amount

/** The split shown for [cost] this month: proportional ones by this month's [basis]. */
private fun previewOf(cost: SharedCost, basis: Map<String, Double>) =
    SharedCostAllocation.allocate(cost, monthTotalOf(cost), cost.workplaceIds, basis)

@Composable
private fun SharedCostCard(
    cost: SharedCost,
    workplaces: Map<String, WorkplaceInfo>,
    basis: Map<String, Double>,
    month: YearMonth?,
    onEdit: () -> Unit,
    onDelete: () -> Unit
) {
    val split = previewOf(cost, basis)
    SurfaceCard(modifier = Modifier.fillMaxWidth()) {
        Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.Top) {
            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
                Text(cost.name, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
                Text(
                    "${formatMoney(cost.amount, cost.currency)} / ${cost.frequency.label()}",
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.primary
                )
                val start = yearMonthOf(cost.startMonth)
                val end = yearMonthOf(cost.endMonth)
                val period = when {
                    cost.frequency == SharedCostFrequency.ONE_OFF -> cost.date.orEmpty()
                    start != null && end != null -> stringResource(Res.string.shared_cost_months_between, monthLabel(start), monthLabel(end))
                    start != null -> stringResource(Res.string.shared_cost_months_from, monthLabel(start))
                    else -> ""
                }
                if (period.isNotEmpty()) Text(period, style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                val basisLabel = cost.basis?.takeIf { cost.method == AllocationMethod.PROPORTIONAL }?.label()
                val method = if (basisLabel != null) "${cost.method.label()} · $basisLabel" else cost.method.label()
                Text(stringResource(Res.string.shared_cost_split_label, method), style = MaterialTheme.typography.bodySmall)
                split.parts.forEach { part ->
                    val name = workplaces[part.workplaceId]?.name ?: part.workplaceId
                    Text(
                        stringResource(
                            Res.string.shared_cost_part, name,
                            stringResource(Res.string.shared_cost_part_share, formatPercent(part.sharePercent), formatMoney(part.amount, cost.currency))
                        ),
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
                if (month != null && cost.method == AllocationMethod.PROPORTIONAL && cost.basis != AllocationBasis.EQUAL && split.fellBackToEqual) {
                    Text(stringResource(Res.string.shared_cost_preview_fallback), style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                }
            }
            IconButtonWithTooltip(onClick = onEdit, tooltip = stringResource(Res.string.edit)) {
                Icon(Icons.Default.Edit, contentDescription = stringResource(Res.string.edit), modifier = Modifier.size(20.dp))
            }
            IconButtonWithTooltip(onClick = onDelete, tooltip = stringResource(Res.string.delete)) {
                Icon(Icons.Default.Delete, contentDescription = stringResource(Res.string.delete), modifier = Modifier.size(20.dp), tint = MaterialTheme.colorScheme.error)
            }
        }
    }
}

/**
 * SH-131: the month across the owner's workplaces: income, costs (the shared costs inside them,
 * shown as "of which"), result. Shared on the owner dashboard.
 */
@Composable
fun BusinessMonthCard(business: BusinessMonth, currency: String, modifier: Modifier = Modifier) {
    SurfaceCard(
        modifier = modifier.fillMaxWidth()
    ) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
            Text(stringResource(Res.string.business_month_title), style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
            HorizontalDivider()
            MoneyRow(stringResource(Res.string.monthly_result_revenue), formatMoney(business.revenue, currency))
            MoneyRow(stringResource(Res.string.monthly_result_costs), formatMoney(business.costs, currency))
            if (business.sharedCosts > 0) {
                MoneyRow(stringResource(Res.string.business_month_shared), formatMoney(business.sharedCosts, currency), indent = true)
            }
            MoneyRow(
                stringResource(Res.string.monthly_result_result),
                formatMoney(business.result, currency),
                bold = true,
                color = if (business.result < 0) MaterialTheme.colorScheme.error else RevenueGreen
            )
            Text(stringResource(Res.string.business_month_note), style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
        }
    }
}

@Composable
private fun MoneyRow(label: String, value: String, bold: Boolean = false, indent: Boolean = false, color: Color = Color.Unspecified) {
    Row(Modifier.fillMaxWidth().padding(start = if (indent) 16.dp else 0.dp), horizontalArrangement = Arrangement.SpaceBetween) {
        Text(label, style = if (indent) MaterialTheme.typography.bodySmall else MaterialTheme.typography.bodyMedium)
        Text(value, fontWeight = if (bold) FontWeight.Bold else FontWeight.Normal, color = color)
    }
}

/**
 * Adding or changing a shared cost: name, total, how often (a date or the months), how to split
 * and across which workplaces, with the split previewed live and a running "adds up" check. Save
 * stays off until percentages make 100% or the amounts make the total.
 */
@Composable
fun SharedCostDialog(
    initial: SharedCost,
    workplaces: Map<String, WorkplaceInfo>,
    basis: Map<AllocationBasis, Map<String, Double>>,
    month: YearMonth?,
    converting: RecurringCostRule?,
    isSaving: Boolean,
    onDismiss: () -> Unit,
    onSave: (SharedCost) -> Unit
) {
    var name by remember { mutableStateOf(initial.name) }
    var amountText by remember { mutableStateOf(if (initial.amount > 0) formatEditable(initial.amount) else "") }
    var frequency by remember { mutableStateOf(initial.frequency) }
    var dateText by remember { mutableStateOf(initial.date.orEmpty()) }
    var startMonth by remember { mutableStateOf(yearMonthOf(initial.startMonth) ?: month) }
    var endMonth by remember { mutableStateOf(yearMonthOf(initial.endMonth)) }
    var method by remember { mutableStateOf(initial.method) }
    var basisChoice by remember { mutableStateOf(initial.basis ?: AllocationBasis.EQUAL) }
    val included = remember { mutableStateMapOf<String, Boolean>().apply { workplaces.keys.forEach { put(it, it in initial.workplaceIds) } } }
    val shareTexts = remember {
        mutableStateMapOf<String, String>().apply { workplaces.keys.forEach { id -> put(id, initial.shares[id]?.takeIf { it != 0.0 }?.let { formatEditable(it) }.orEmpty()) } }
    }
    var tried by remember { mutableStateOf(false) }

    val currency = initial.currency
    val amount = parseDecimal(amountText)
    val chosen = workplaces.keys.filter { included[it] == true }
    val draft = SharedCost(
        id = initial.id,
        name = name.trim(),
        amount = amount ?: 0.0,
        currency = currency,
        frequency = frequency,
        date = if (frequency == SharedCostFrequency.ONE_OFF) parseIsoDate(dateText)?.toString() else null,
        startMonth = if (frequency == SharedCostFrequency.ONE_OFF) null else startMonth?.toString(),
        endMonth = if (frequency == SharedCostFrequency.ONE_OFF) null else endMonth?.toString(),
        method = method,
        basis = if (method == AllocationMethod.PROPORTIONAL) basisChoice else null,
        workplaceIds = chosen,
        shares = if (method == AllocationMethod.PROPORTIONAL) emptyMap() else chosen.associateWith { parseDecimal(shareTexts[it].orEmpty()) ?: 0.0 }
    )
    val problems = SharedCostAllocation.problems(draft)
    val required = stringResource(Res.string.field_required)
    val months = remember(month) {
        val now = month ?: return@remember emptyList()
        generateSequence(now.minusMonth().minusMonth().minusMonth()) { it.plusMonth() }.take(16).toList()
    }

    EvoDialog(
        title = stringResource(if (initial.id.isBlank()) (if (converting != null) Res.string.shared_cost_convert_title else Res.string.shared_cost_add_title) else Res.string.shared_cost_edit_title),
        icon = Icons.AutoMirrored.Filled.CallSplit,
        width = DialogWidth.Regular,
        onDismiss = onDismiss,
        confirm = DialogAction(
            stringResource(Res.string.save),
            {
                tried = true
                if (problems.isEmpty()) onSave(draft)
            },
            // Saving is blocked until the split adds up.
            enabled = problems.none { it == SharedCostAllocation.Problem.PERCENTAGES_NOT_100 || it == SharedCostAllocation.Problem.AMOUNTS_NOT_TOTAL },
            loading = isSaving
        )
    ) {
        converting?.let { rule ->
            Text(
                stringResource(Res.string.shared_cost_convert_note, workplaces[rule.targetWorkplaceId]?.name ?: rule.targetWorkplaceId),
                style = MaterialTheme.typography.bodySmall,
                color = Color.White.copy(alpha = 0.85f)
            )
        }
        EvoTextField(
            value = name,
            onValueChange = { name = it },
            label = stringResource(Res.string.name),
            placeholder = stringResource(Res.string.shared_cost_name_hint),
            error = required.takeIf { tried && name.isBlank() }
        )
        EvoTextField(
            value = amountText,
            onValueChange = { amountText = it },
            label = stringResource(Res.string.shared_cost_amount, currency),
            keyboardType = KeyboardType.Decimal,
            suffix = currency,
            error = when {
                amountText.isNotBlank() && amount == null -> stringResource(Res.string.number_invalid)
                tried && (amount == null || amount <= 0.0) -> required
                else -> null
            }
        )
        EvoDropdown(
            label = stringResource(Res.string.shared_cost_frequency),
            options = SharedCostFrequency.entries.toList(),
            selected = frequency,
            onSelected = { frequency = it },
            optionLabel = { it.label() }
        )
        if (frequency == SharedCostFrequency.ONE_OFF) {
            EvoDateField(
                value = dateText,
                onValueChange = { dateText = it },
                label = stringResource(Res.string.shared_cost_date),
                showErrors = tried
            )
        } else if (months.isNotEmpty()) {
            EvoDropdown(
                label = stringResource(Res.string.shared_cost_start_month),
                options = months,
                selected = startMonth,
                onSelected = { startMonth = it },
                optionLabel = { monthLabel(it) }
            )
            // "" is "no end" (a dropdown shows nothing for a null choice).
            val ends: List<String> = listOf("") + months.filter { start -> startMonth?.let { start >= it } ?: true }.map { it.toString() }
            EvoDropdown(
                label = stringResource(Res.string.shared_cost_end_month),
                options = ends,
                selected = endMonth?.toString() ?: "",
                onSelected = { endMonth = yearMonthOf(it) },
                optionLabel = { key -> yearMonthOf(key)?.let { m -> monthLabel(m) } ?: stringResource(Res.string.shared_cost_no_end) },
                error = stringResource(Res.string.shared_cost_error_end).takeIf { SharedCostAllocation.Problem.END_BEFORE_START in problems }
            )
        }

        EvoDropdown(
            label = stringResource(Res.string.shared_cost_method),
            options = AllocationMethod.entries.toList(),
            selected = method,
            onSelected = { method = it },
            optionLabel = { it.label() }
        )
        if (method == AllocationMethod.PROPORTIONAL) {
            EvoDropdown(
                label = stringResource(Res.string.shared_cost_basis),
                options = AllocationBasis.entries.toList(),
                selected = basisChoice,
                onSelected = { basisChoice = it },
                optionLabel = { it.label() }
            )
        }

        DialogSectionLabel(stringResource(Res.string.shared_cost_workplaces))
        workplaces.values.forEach { wp ->
            EvoCheckboxRow(checked = included[wp.id] == true, onCheckedChange = { included[wp.id] = it }, label = wp.name)
            if (included[wp.id] == true && method != AllocationMethod.PROPORTIONAL) {
                val text = shareTexts[wp.id].orEmpty()
                val value = parseDecimal(text)
                EvoTextField(
                    value = text,
                    onValueChange = { shareTexts[wp.id] = it },
                    label = wp.name,
                    keyboardType = KeyboardType.Decimal,
                    suffix = if (method == AllocationMethod.PERCENTAGES) "%" else currency,
                    error = when {
                        text.isNotBlank() && value == null -> stringResource(Res.string.number_invalid)
                        value != null && value < 0 -> stringResource(Res.string.shared_cost_error_negative)
                        else -> null
                    }
                )
            }
        }
        if (chosen.isEmpty()) {
            Text(stringResource(Res.string.shared_cost_error_workplaces), style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.error)
        }

        if (chosen.isNotEmpty()) {
            DialogSectionLabel(stringResource(Res.string.shared_cost_preview_title))
            val split = previewOf(draft, basis[basisChoice].orEmpty())
            split.parts.forEach { part ->
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                    Text(workplaces[part.workplaceId]?.name ?: part.workplaceId, color = Color.White, modifier = Modifier.weight(1f))
                    Spacer(Modifier.width(8.dp))
                    Text(
                        stringResource(Res.string.shared_cost_part_share, formatPercent(part.sharePercent), formatMoney(part.amount, currency)),
                        color = Color.White,
                        fontWeight = FontWeight.SemiBold
                    )
                }
            }
            when (method) {
                AllocationMethod.PROPORTIONAL -> {
                    Text(basisChoice.note(), style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.8f))
                    if (split.fellBackToEqual) {
                        Text(stringResource(Res.string.shared_cost_preview_fallback), style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.8f))
                    }
                }
                else -> SumCheck(draft, currency)
            }
        }
    }
}

/** The running "adds up" line: a tick when it does, else what is missing or over. */
@Composable
private fun SumCheck(draft: SharedCost, currency: String) {
    val shortfall = SharedCostAllocation.shortfall(draft)
    val ok = SharedCostAllocation.toCents(shortfall) == 0L
    val percent = draft.method == AllocationMethod.PERCENTAGES
    val text = when {
        ok -> stringResource(Res.string.shared_cost_sum_ok)
        percent && shortfall > 0 -> stringResource(Res.string.shared_cost_sum_missing_percent, formatPercent(shortfall).removeSuffix("%"))
        percent -> stringResource(Res.string.shared_cost_sum_over_percent, formatPercent(-shortfall).removeSuffix("%"))
        shortfall > 0 -> stringResource(Res.string.shared_cost_sum_missing_amount, formatMoney(shortfall, currency))
        else -> stringResource(Res.string.shared_cost_sum_over_amount, formatMoney(-shortfall, currency))
    }
    Row(verticalAlignment = Alignment.CenterVertically) {
        Icon(
            if (ok) Icons.Default.CheckCircle else Icons.Default.Warning,
            contentDescription = null,
            tint = if (ok) Color(0xFF81C784) else Color(0xFFFFB74D),
            modifier = Modifier.size(18.dp)
        )
        Spacer(Modifier.width(6.dp))
        Text(text, color = if (ok) Color(0xFF81C784) else Color(0xFFFFB74D), style = MaterialTheme.typography.bodyMedium)
    }
}

/**
 * SH-131: the profile's "Koszty wspólne firmy" section, apart from the workplaces' monthly costs:
 * what it is, how many there are, and the way in.
 */
@Composable
fun SharedCostsProfileSection(count: Int?, onOpen: () -> Unit) {
    Column(modifier = Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Text(stringResource(Res.string.shared_costs_title), style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
        Text(
            stringResource(Res.string.shared_costs_intro),
            style = MaterialTheme.typography.bodySmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant
        )
        if (count != null && count > 0) {
            Text(stringResource(Res.string.shared_costs_count, count), style = MaterialTheme.typography.bodyMedium)
        }
        androidx.compose.material3.TextButton(onClick = onOpen, modifier = Modifier.align(Alignment.End)) {
            Icon(Icons.AutoMirrored.Filled.CallSplit, contentDescription = null)
            Spacer(Modifier.width(4.dp))
            Text(stringResource(if (count == null || count == 0) Res.string.shared_costs_add_first else Res.string.shared_costs_manage))
        }
    }
}
